import * as React from 'react';
import { Handle, Position } from 'reactflow';
import './customNode.scss';
import {
	ReactFlowHelpNodeIDList,
	ReactFlowNodeSize,
	ReactFlowNodeStatus,
	ReactFlowNodeType,
} from './customNodeEnums';
import { CustomNode } from './customNode.interface';
import { Hotspot } from '@amzn/awsui-components-console';
import { TUTORIAL_KEYNAME_LOCAL_STORAGE } from 'src/constants/browserStorageConstants';
import { SUB_WORKFLOW_TASK_TYPE } from 'src/constants/CommonConstants';

// unidirectional is associated with the incoming attribute.
// isClickable can also be associated to nodeType
// status will decide the color, bg color, border.
export default function CustomNodeTypeHOC(
	nodeType = ReactFlowNodeType.BI_DIRECTIONAL
) {
	return function CustomReactFlowNode({
		data,
		id,
		isConnectable,
		selected,
	}: CustomNode) {
		const {
			status = ReactFlowNodeStatus.CREATING,
			isClickable = true,
			isIncoming = false,
			name,
			shape,
			size = ReactFlowNodeSize.DEFAULT,
			alignment,
			showHotspot = false,
		} = data.nodeAdditionalProps;

		const isIncomingConnectorRequired =
			nodeType === ReactFlowNodeType.BI_DIRECTIONAL ||
			(nodeType === ReactFlowNodeType.UNI_DIRECTIONAL && isIncoming);
		const isOutgoingConnectorRequired =
			nodeType === ReactFlowNodeType.BI_DIRECTIONAL ||
			(nodeType === ReactFlowNodeType.UNI_DIRECTIONAL && !isIncoming);

		const isHorizontal = alignment === 'LR';
		const targetPosition = isHorizontal ? Position.Left : Position.Top;
		const sourcePosition = isHorizontal ? Position.Right : Position.Bottom;
		const isSubWorkflow = data.taskDefinition?.taskType === SUB_WORKFLOW_TASK_TYPE;

		return (
			<React.Fragment>
				{isSubWorkflow && (
					<span className="customNode__subWorkflowMarker" data-testid={`${id}subWorkflowMarker`}>
						<span className="customNode__subWorkflowMarkerIcon" aria-hidden="true">🧩</span>
						Sub-workflow
					</span>
				)}
				<button
					data-testid={id}
					className={`customNode customNode-status--${status} ${
						!isClickable ? 'customNode--isNotClickable' : ''
					} ${
						selected ? 'customNode--selected' : ''
					} customNode-shape--${shape} customNode-size--${size}`}
				>
					{isIncomingConnectorRequired && (
						<Handle
							type="target"
							data-testid={`${id}inComingHandle`}
							position={targetPosition}
							isConnectable={isConnectable}
						/>
					)}
					{name}
					{isOutgoingConnectorRequired && (
						<Handle
							type="source"
							position={sourcePosition}
							data-testid={`${id}outGoingHandle`}
							id="handle"
							isConnectable={isConnectable}
						/>
					)}
				</button>
				{showHotspot &&
					!localStorage.getItem(TUTORIAL_KEYNAME_LOCAL_STORAGE) &&
					id === ReactFlowHelpNodeIDList.START && (
						<Hotspot
							className="hotSpot"
							direction="top"
							side="right"
							hotspotId="drag-and-drop-box"
						/>
					)}
			</React.Fragment>
		);
	};
}
